import React, { useEffect, useState } from "react";
import { getTaxes, deleteTax } from "../../api/TaxService";
import { FaEye, FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { getErrorMessage } from "../../utils/errorHandler";
import { useNavigate } from "react-router-dom";
export default function TaxList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getTaxes();
      setList(res?.data || res || []);
    } catch (err) {
      setError("Failed to load tax list");
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Delete this tax?")) return;
      await deleteTax(id);
      setSuccess("Tax deleted successfully");
      loadData();
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to delete tax");
      alert(getErrorMessage(error));
      setTimeout(() => setError(""), 3000);
    }
  };
  if (loading) {
    return (
      <div className="d-flex vh-100 w-100 align-items-center justify-content-center">
        <p className="m-0">Loading Taxes...</p>
      </div>
    );
  }
  return (
    <div className="container-fluid p-4">
      {/* SUCCESS / ERROR */}
      {success && <div className="alert alert-success">{success}</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Tax List</h5>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/tax/add")}
        >
          <FaPlus /> Add Tax
        </button>
      </div>
      {/* CARD */}
      <div className="card p-3 shadow-sm">
        <table className="table table-bordered table-hover bg-white">
          <thead style={{ background: "#f5f5f5" }}>
            <tr>
              <th className="text-dark fw-bold">#</th>
              <th className="text-dark fw-bold">Tax Name</th>
               <th className="text-dark fw-bold">CGST (%)</th>
               <th className="text-dark fw-bold">SGST (%)</th>
               <th className="text-dark fw-bold">IGST (%)</th>
               <th className="text-dark fw-bold">Total (%)</th>
              <th className="text-dark fw-bold">ACTION</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center">
                  No Tax Found
                </td>
              </tr>
            )}
            {list.map((tax, index) => (
              <tr key={tax._id}>
                <td>{index + 1}</td>
                <td>{tax.taxName}</td>
                <td>{tax.cgstPercentage}</td>
                <td>{tax.sgstPercentage}</td>
                <td>{tax.igstPercentage}</td>
                <td>
                  {(tax.cgstPercentage || 0) +
                    (tax.sgstPercentage || 0) +
                    (tax.igstPercentage || 0)}
                </td>
                <td className="text-center">
                  <div className="d-flex justify-content-center gap-3">
                    <FaEye
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/tax/view/${tax.taxName}`, {
                          state: { taxId: tax._id },
                        })
                      }
                    />
                    <FaEdit
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/tax/edit", {
                          state: { taxId: tax._id },
                        })
                      }
                    />

                    {/* DELETE */}
                    <FaTrash
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDelete(tax._id)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
